import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { Polygon } from "geojson";

import { apiErrorGeneric, getAxiosInstance, handleAxiosError } from "./Utils";

export class Api {
  static async get(
    path: string,
    config?: AxiosRequestConfig,
  ): Promise<IApiSuccess> {
    /**
     * Make a GET request.
     * On success, resolve with the response.
     * On error, reject with the error.
     */
    return getAxiosInstance().then((axiosInstance) =>
      axiosInstance
        .get(path, { ...config })
        .then((response: AxiosResponse) => {
          if ([200].includes(response.status)) {
            return { isSuccessful: true, ...response } as IApiSuccess;
          } else {
            return Promise.reject(apiErrorGeneric);
          }
        })
        .catch((error: AxiosError) =>
          handleAxiosError(error).then((apiError: IApiError) =>
            Promise.reject(apiError),
          ),
        ),
    );
  }

  static async post(
    path: string,
    data:
      FormData | { [key: string]: string | string[] | Polygon | null | number },
    config?: AxiosRequestConfig,
  ): Promise<IApiSuccess> {
    /**
     * Make a POST request.
     * On success, resolve with the response.
     * On error, reject with the error.
     */
    return getAxiosInstance().then((axiosInstance) =>
      axiosInstance
        .post(path, data, { ...config })
        .then((response: AxiosResponse) => {
          if ([200, 201].includes(response.status)) {
            return { isSuccessful: true, ...response } as IApiSuccess;
          } else {
            return Promise.reject(apiErrorGeneric);
          }
        })
        .catch((error: AxiosError) =>
          handleAxiosError(error).then((apiError: IApiError) =>
            Promise.reject(apiError),
          ),
        ),
    );
  }

  static async patch(
    path: string,
    data: FormData | { [key: string]: string | boolean | number | undefined },
  ): Promise<IApiSuccess> {
    /**
     * Make a PATCH request.
     * On success, resolve with the response.
     * On error, reject with the error.
     */
    return getAxiosInstance().then((axiosInstance) =>
      axiosInstance
        .patch(path, data)
        .then((response: AxiosResponse) => {
          if ([200, 202, 204].includes(response.status)) {
            return { isSuccessful: true, ...response } as IApiSuccess;
          } else {
            return Promise.reject(apiErrorGeneric);
          }
        })
        .catch((error: AxiosError) =>
          handleAxiosError(error).then((apiError: IApiError) =>
            Promise.reject(apiError),
          ),
        ),
    );
  }

  static async delete(path: string): Promise<IApiSuccess> {
    /**
     * Make a DELETE request.
     * On success, resolve with the response.
     * On error, reject with the error.
     */
    return getAxiosInstance().then((axiosInstance) =>
      axiosInstance
        .delete(path)
        .then((response: AxiosResponse) => {
          if ([200, 204].includes(response.status)) {
            return { isSuccessful: true, ...response } as IApiSuccess;
          } else {
            return Promise.reject(apiErrorGeneric);
          }
        })
        .catch((error: AxiosError) =>
          handleAxiosError(error).then((apiError: IApiError) =>
            Promise.reject(apiError),
          ),
        ),
    );
  }
}
